import COLORS from 'pared/constants/colors'
import { ILossPreventionConfigType } from 'pared/pages/CorporateLossPrevention/hooks/useLossPreventionConfig'

export const supremePopConfig: ILossPreventionConfigType = {
  kpiSettings: [
    { category: 'basic', key: 'compsTotalAmount', title: 'Total Discounts' },
    { category: 'basic', key: 'cashOverOrShort', title: 'Cash +/-' },
    {
      category: 'custom',
      type: 'Over Ring',
      title: '% Checks with Over Ring',
      key: 'checkPercent',
    },
    {
      category: 'custom',
      type: 'Deal after Total',
      title: '% Checks with Deletes',
      key: 'checkPercent',
    },
    {
      category: 'basic',
      key: 'inaccurateCashierShiftPercent',
      title: '% Shifts with Inaccurate Cash',
    },
  ],

  discountTable: {
    isVisible: true,
    discountColumns: [
      {
        key: 'D - Guest Satisfaction',
        title: 'Guest Satisfaction',
      },
      {
        key: 'D - Crew Meal',
        title: 'Crew Meal',
      },
      {
        key: 'D - Manager Meal',
        title: 'Manager Meal',
      },
      {
        key: 'D - Senior',
        title: 'Senior',
      },
      {
        key: 'D - Percentage #1',
        title: 'Percentage #1',
      },
      {
        key: 'D - Percentage #2',
        title: 'Percentage #2',
      },
    ],
  },

  discountTrendChart: {
    isVisible: true,
    yLeftAxisLabel: '$ Discount',
    yLeftAxisValueType: 'cent',
    yLeftAxisKpiDefs: [
      {
        key: 'D - Guest Satisfaction',
        name: 'Guest Satisfaction',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Acai,
        hidden: true,
      },
      {
        key: 'D - Crew Meal',
        name: 'Crew Meal',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Plum,
        hidden: true,
      },
      {
        key: 'D - Manager Meal',
        name: 'Manager Meal',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.DarkOrchid,
        hidden: true,
      },
      {
        key: 'D - Percentage #1',
        name: 'Percentage #1',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Mango,
        hidden: true,
      },
      {
        key: 'D - Percentage #2',
        name: 'Percentage #2',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Steel,
        hidden: true,
      },
      {
        key: 'D - Senior',
        name: 'Senior',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Basil,
        hidden: true,
      },
    ],
  },

  cashControlTable: {
    isVisible: true,
    cashControlColumns: [
      {
        key: 'cashOverOrShort',
        title: 'Cash +/-',
        width: '150px',
        children: [
          {
            key: 'cashOverOrShort.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'cashOverOrShort.amount',
            title: '$',
            valueType: 'price',
          },
        ],
      },
      {
        key: 'Over Ring',
        title: 'Over Ring',
        width: '150px',
        children: [
          {
            key: 'Over Ring.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'Over Ring.amount',
            title: '$',
            valueType: 'price',
          },
        ],
      },
      {
        key: 'Deal after Total',
        title: 'Deletes',
        width: '150px',
        children: [
          {
            key: 'Deal after Total.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'Deal after Total.amount',
            title: '$',
            valueType: 'price',
          },
        ],
      },
      {
        key: 'cashOverOrShort.checkPercent',
        title: '% Shifts with Inaccurate Cash',
        valueType: 'percent',
        width: '150px',
      },
      {
        key: 'Over Ring.checkPercent',
        title: '% Checks w/ Over Ring',
        valueType: 'percent',
        width: '150px',
      },
      {
        key: 'Deal after Total.checkPercent',
        title: '% Checks w/ Deletes',
        valueType: 'percent',
        width: '150px',
      },
    ],
  },

  cashControlTrendChart: {
    isVisible: true,
    yLeftAxisLabel: '$ Amount',
    yLeftAxisValueType: 'cent',
    yLeftAxisKpiDefs: [
      {
        key: 'cashOverOrShort',
        name: 'Cash +/- $',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Pomodoro,
      },
      {
        key: 'Over Ring',
        name: 'Over Ring $',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Plum,
        hidden: true,
      },
      {
        key: 'Deal after Total',
        name: 'Deletes $',
        kpiKey: 'amount',
        valueType: 'cent',
        color: COLORS.Basil,
        hidden: true,
      },
    ],
  },
}
